// extracted by mini-css-extract-plugin
module.exports = {"page_location":"_F3z6wPXL","region":"_iInPnPP_"};